export const nationalities = [
    "Afghanistan",
    "Afrique du Sud",
    "Aland",
    "Albanie",
    "Algérie",
    "Allemagne",
    "Andorre",
    "Angola",
    "Anguilla",
    "Antarctique",
    "Antigua-et-Barbuda",
    "Arabie saoudite",
    "Argentine",
    "Arménie",
    "Aruba",
    "Australie",
    "Autriche",
    "Azerbaïdjan",
    "Bahamas",
    "Bahreïn",
    "Bangladesh",
    "Barbade",
    "Biélorussie",
    "Belgique",
    "Belize",
    "Bénin",
    "Bermudes",
    "Bhoutan",
    "Bolivie",
    "Bonaire",
    " Saint-Eustache et Saba",
    "Bosnie-Herzégovine",
    "Botswana",
    "Île Bouvet",
    "Brésil",
    "Brunei",
    "Bulgarie",
    "Burkina Faso",
    "Burundi",
    "Îles Caïmans",
    "Cambodge",
    "Cameroun",
    "Canada",
    "Cap-Vert",
    "République centrafricaine",
    "Chili",
    "Chine",
    "Île Christmas",
    "Chypre",
    "Îles Cocos",
    "Colombie",
    "Comores",
    "République du Congo",
    "République démocratique du Congo",
    "Îles Cook",
    "Corée du Sud",
    "Corée du Nord",
    "Costa Rica",
    "Côte d'Ivoire",
    "Croatie",
    "Cuba",
    "Curaçao",
    "Danemark",
    "Djibouti",
    "République dominicaine",
    "Dominique",
    "Égypte",
    "Salvador",
    "Émirats arabes unis",
    "Équateur",
    "Érythrée",
    "Espagne",
    "Estonie",
    "États-Unis",
    "Éthiopie",
    "Îles Malouines",
    "Îles Féroé",
    "Fidji",
    "Finlande",
    "France",
    "Gabon",
    "Gambie",
    "Géorgie",
    "Géorgie du Sud-et-les Îles Sandwich du Sud",
    "Ghana",
    "Gibraltar",
    "Grèce",
    "Grenade",
    "Groenland",
    "Guadeloupe",
    "Guam",
    "Guatemala",
    "Guernesey",
    "Guinée",
    "Guinée-Bissau",
    "Guinée équatoriale",
    "Guyana",
    "Guyane",
    "Haïti",
    "Îles Heard-et-MacDonald",
    "Honduras",
    "Hong Kong",
    "Hongrie",
    "Île de Man",
    "Îles mineures éloignées des États-Unis",
    "Îles Vierges britanniques",
    "Îles Vierges des États-Unis",
    "Inde",
    "Indonésie",
    "Iran",
    "Irak",
    "Irlande",
    "Islande",
    "Italie",
    "Jamaïque",
    "Japon",
    "Jersey",
    "Jordanie",
    "Kazakhstan",
    "Kenya",
    "Kirghizistan",
    "Kiribati",
    "Koweït",
    "Laos",
    "Lesotho",
    "Lettonie",
    "Liban",
    "Liberia",
    "Libye",
    "Liechtenstein",
    "Lituanie",
    "Luxembourg",
    "Macao",
    "Macédoine",
    "Madagascar",
    "Malaisie",
    "Malawi",
    "Maldives",
    "Mali",
    "Malte",
    "Îles Mariannes du Nord",
    "Maroc",
    "Marshall",
    "Martinique",
    "Maurice",
    "Mauritanie",
    "Mayotte",
    "Mexique",
    "Micronésie",
    "Moldavie",
    "Monaco",
    "Mongolie",
    "Monténégro",
    "Montserrat",
    "Mozambique",
    "Birmanie",
    "Namibie",
    "Nauru",
    "Népal",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Niue",
    "Île Norfolk",
    "Norvège",
    "Nouvelle-Calédonie",
    "Nouvelle-Zélande",
    "Territoire britannique de l'océan Indien",
    "Oman",
    "Ouganda",
    "Ouzbékistan",
    "Pakistan",
    "Palaos",
    "Palestine",
    "Panama",
    "Papouasie-Nouvelle-Guinée",
    "Paraguay",
    "Pays-Bas",
    "Pérou",
    "Philippines",
    "Îles Pitcairn",
    "Pologne",
    "Polynésie française",
    "Porto Rico",
    "Portugal",
    "Qatar",
    "La Réunion",
    "Roumanie",
    "Royaume-Uni",
    "Russie",
    "Rwanda",
    "Sahara occidental",
    "Saint-Barthélemy",
    "Saint-Christophe-et-Niévès",
    "Saint-Marin",
    "Saint-Martin (Antilles françaises)",
    "Saint-Martin",
    "Saint-Pierre-et-Miquelon",
    "Saint-Siège (État de la Cité du Vatican)",
    "Saint-Vincent-et-les-Grenadines",
    "Sainte-Hélène",
    " Ascension et Tristan da Cunha",
    "Sainte-Lucie",
    "Salomon",
    "Samoa",
    "Samoa américaines",
    "Sao Tomé-et-Principe",
    "Sénégal",
    "Serbie",
    "Seychelles",
    "Sierra Leone",
    "Singapour",
    "Slovaquie",
    "Slovénie",
    "Somalie",
    "Soudan",
    "Soudan du Sud",
    "Sri Lanka",
    "Suède",
    "Suisse",
    "Suriname",
    "Svalbard et Île Jan Mayen",
    "Swaziland",
    "Syrie",
    "Tadjikistan",
    "Taïwan / (République de Chine (Taïwan))",
    "Tanzanie",
    "Tchad",
    "République tchèque",
    "Terres australes et antarctiques françaises",
    "Thaïlande",
    "Timor oriental",
    "Togo",
    "Tokelau",
    "Tonga",
    "Trinité-et-Tobago",
    "Tunisie",
    "Turkménistan",
    "Îles Turques-et-Caïques",
    "Turquie",
    "Tuvalu",
    "Ukraine",
    "Uruguay",
    "Vanuatu",
    "Venezuela",
    "Viêt Nam",
    "Wallis-et-Futuna",
    "Yémen",
    "Zambie",
    "Zimbabwe",
  ];
  